/* global localData */
if (document.querySelector('.sc-membership-list')) {
  const memberPopUp = (() => {
    const r = {
      popUp: document.querySelector('.modal__body .editor-text'),
      buttons: document.querySelectorAll('.membership-list__logo'),
      modal: document.querySelector('.sc-membership-list .modal'),
      loading: false,
      sendAjax: (e) => {
        r.loading = true;
        const { id } = e.target.closest('.membership-list__logo').dataset;
        const { type } = e.target.closest('.sc-membership-list').dataset;
        const request = new XMLHttpRequest();
        request.open('POST', localData.siteURL, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        request.send(`action=getPopUpMember&id=${id}&nonce=${localData.nonce}&lang=${localData.lang}&type=${type}`);
        request.onreadystatechange = function () {
          if (this.readyState === 4 && this.status === 200) {
            const response = JSON.parse(this.responseText);
            if (response.data.status === 200) {
              r.modal.classList.add('is-open-modal');
              r.popUp.innerHTML = response.data.html;
            }
          }
          r.loading = false;
        };
      },
      initButtons: () => {
        r.buttons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!r.loading) {
              r.sendAjax(e);
            }
          });
        });
      },
    };
    return {
      initialize: () => {
        r.initButtons();
      },
    };
  })();
  memberPopUp.initialize();
}
